

exports.__esModule = true;
exports.formatReturnContent = formatReturnContent;
var MAX_MERCHANT_NAME_LENGTH = exports.MAX_MERCHANT_NAME_LENGTH = 15;

function formatReturnContent($renderContent, merchantName) {
    if (merchantName && merchantName.length < MAX_MERCHANT_NAME_LENGTH) {
        return $renderContent('common.returnToMerchant', { merchantName: merchantName });
    }

    return $renderContent('common.returnToDefaultMerchant');
}


//////////////////
// WEBPACK FOOTER
// ./components/xo-return-to-merchant/dist/formatReturnContent.js
// module id = ./components/xo-return-to-merchant/dist/formatReturnContent.js
// module chunks = 1